import {ICorrectionWayPointSingleVoyage} from "@containers/singleVoyage/types/point";
import {getRandomNumber} from "@helpers/number/getRandomNumber";

export const createCorrectionWayPointByLatLng = ({
                                                     lat,
                                                     lng,
                                                 }: {
    lat: number,
    lng: number,
}): ICorrectionWayPointSingleVoyage => {
    return {
        lat,
        lng,
        id: getRandomNumber()
    }
}